import { GeometryType } from "@evergis/api";
import {
  CalculatedParameterDc,
  SolidFillBrushDc,
  SolidStrokeBrushDc,
} from "@evergis/api/dist/__generated__/data-contracts";
import {
  LayerSymbol,
  PointSymbol,
  PolygonSymbol,
  StrokeBrushType,
  FillBrushType,
  RasterSymbol,
  MultipointSymbol,
  SimplePolylineSymbol,
} from "../../../interfaces/style";
import { EditGeometryType } from "../../../evergis/core/attributes/geometryTypes";

const blankStrokeBrush: StrokeBrushType = {
  type: "solid",
  color: null,
  width: 2,
};

const blankFillBrush: FillBrushType = {
  type: "solid",
  color: null,
};

const blankSymbols: Partial<Record<GeometryType | EditGeometryType, LayerSymbol>> = {
  point: {
    type: "circlePointSymbol",
    offset: [0, 0],
    fillColor: null,
    strokeColor: null,
    strokeWidth: 1,
    size: 7,
  },
  polyline: {
    type: "simplePolylineSymbol",
    stroke: blankStrokeBrush,
  },
  multipolygon: {
    type: "polygonSymbol",
    fill: blankFillBrush,
    stroke: blankStrokeBrush,
  },
  multipoint: {
    type: "multipointSymbol",
    pointSymbol: {
      type: "circlePointSymbol",
      offset: [0, 0],
      strokeColor: null,
      strokeWidth: 1,
      size: 7,
      fillColor: null,
    },
  },
  raster: {
    type: "compositeSymbol",
    childSymbols: [
      {
        type: "polygonSymbol",
        stroke: blankStrokeBrush as SolidStrokeBrushDc,
        fill: blankFillBrush as SolidFillBrushDc,
      },
      {
        type: "rasterSymbol",
        opacity: 1 as CalculatedParameterDc,
      },
    ],
  },
};

export function getBlankSymbol(geometryType: GeometryType.Point): PointSymbol;
export function getBlankSymbol(geometryType: GeometryType.Polyline): SimplePolylineSymbol;
export function getBlankSymbol(geometryType: GeometryType.Polygon): PolygonSymbol;
export function getBlankSymbol(geometryType: GeometryType.Multipoint): MultipointSymbol;
export function getBlankSymbol(geometryType: EditGeometryType.Raster): RasterSymbol;
export function getBlankSymbol(geometryType: GeometryType | EditGeometryType): LayerSymbol;
export function getBlankSymbol(geometryType: GeometryType | EditGeometryType): LayerSymbol {
  return blankSymbols[geometryType] || ({} as LayerSymbol);
}
